module.exports = __webpack_public_path__ + "img/qft-dagger.32537a89.svg";